import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Users, ArrowRight } from 'lucide-react';
import DistributorCard from '../../../components/common/distributorCard/DistributorCard';
import '../../../assets/styles/customer/layout/AllDistributorsSection.css';

const AllDistributorsSection = () => {
  const [visibleCount, setVisibleCount] = useState(8);

  const allDistributors = [
    {
      id: 1,
      name: 'Hassan Milk Supply',
      image: 'https://images.unsplash.com/photo-1563636619-e9143da7973b?w=600&q=80',
      rating: 4.6,
      description: 'Fresh and pure milk delivered daily with care and hygiene',
      location: 'Faisalabad, Pakistan',
      price: '165',
      deliveries: '720',
      customers: '280+'
    },
    {
      id: 2,
      name: 'City Dairy Co.',
      image: 'https://images.unsplash.com/photo-1628088062854-d1870b4553da?w=600&q=80',
      rating: 4.3,
      description: 'Urban dairy service with fresh milk delivered to your door',
      location: 'Multan, Pakistan',
      price: '160',
      deliveries: '650',
      customers: '240+'
    },
    {
      id: 3,
      name: 'Fresh Harvest Milk',
      image: 'https://images.unsplash.com/photo-1550583724-b2692b85b150?w=600&q=80',
      rating: 4.5,
      description: 'Farm-to-table fresh milk with guaranteed quality standards',
      location: 'Rawalpindi, Pakistan',
      price: '170',
      deliveries: '890',
      customers: '310+'
    },
    {
      id: 4,
      name: 'Sunrise Dairy',
      image: 'https://images.unsplash.com/photo-1600788907416-456578634209?w=600&q=80',
      rating: 4.4,
      description: 'Morning fresh milk delivered at your doorstep daily',
      location: 'Quetta, Pakistan',
      price: '155',
      deliveries: '580',
      customers: '210+'
    },
    {
      id: 5,
      name: 'Golden Milk Farm',
      image: 'https://images.unsplash.com/photo-1606312619070-d48b4cca5bf3?w=600&q=80',
      rating: 4.7,
      description: 'Premium quality golden milk from healthy grass-fed cows',
      location: 'Sialkot, Pakistan',
      price: '195',
      deliveries: '1.1K',
      customers: '420+'
    },
    {
      id: 6,
      name: 'Organic Dairy Hub',
      image: 'https://images.unsplash.com/photo-1628088062854-d1870b4553da?w=600&q=80',
      rating: 4.5,
      description: 'Certified organic milk from farms with sustainable practices',
      location: 'Gujranwala, Pakistan',
      price: '200',
      deliveries: '950',
      customers: '380+'
    },
    {
      id: 7,
      name: 'Village Fresh Milk',
      image: 'https://images.unsplash.com/photo-1550583724-b2692b85b150?w=600&q=80',
      rating: 4.1,
      description: 'Traditional village-style fresh milk with natural goodness',
      location: 'Sargodha, Pakistan',
      price: '150',
      deliveries: '520',
      customers: '190+'
    },
    {
      id: 8,
      name: 'Premium Dairy Market',
      image: 'https://images.unsplash.com/photo-1600788907416-456578634209?w=600&q=80',
      rating: 4.6,
      description: 'High-quality premium milk with advanced hygiene standards',
      location: 'Peshawar, Pakistan',
      price: '185',
      deliveries: '840',
      customers: '330+'
    },
    {
      id: 9,
      name: 'Nature Valley Dairy',
      image: 'https://images.unsplash.com/photo-1606312619070-d48b4cca5bf3?w=600&q=80',
      rating: 4.4,
      description: 'Natural and pure milk from valley farms delivered fresh',
      location: 'Abbottabad, Pakistan',
      price: '175',
      deliveries: '690',
      customers: '260+'
    },
    {
      id: 10,
      name: 'Family Milk Service',
      image: 'https://images.unsplash.com/photo-1628088062854-d1870b4553da?w=600&q=80',
      rating: 4.3,
      description: 'Trusted family-run dairy with consistent quality service',
      location: 'Bahawalpur, Pakistan',
      price: '158',
      deliveries: '610',
      customers: '230+'
    },
    {
      id: 11,
      name: 'Royal Dairy Farms',
      image: 'https://images.unsplash.com/photo-1550583724-b2692b85b150?w=600&q=80',
      rating: 4.8,
      description: 'Royal quality milk from well-maintained premium farms',
      location: 'Hyderabad, Pakistan',
      price: '192',
      deliveries: '1.3K',
      customers: '480+'
    },
    {
      id: 12,
      name: 'Green Pasture Milk',
      image: 'https://images.unsplash.com/photo-1600788907416-456578634209?w=600&q=80',
      rating: 4.2,
      description: 'Milk from cows grazing on natural green pastures',
      location: 'Sukkur, Pakistan',
      price: '162',
      deliveries: '570',
      customers: '215+'
    }
  ];

  const handleLoadMore = () => {
    setVisibleCount(prevCount => Math.min(prevCount + 4, allDistributors.length));
  };

  const visibleDistributors = allDistributors.slice(0, visibleCount);
  const hasMore = visibleCount < allDistributors.length;

  return (
    <section className="all-distributors-section">
      
      {/* Floating Elements */}
      <div className="all-dist-floating">
        <div className="all-dist-circle circle-1"></div>
        <div className="all-dist-circle circle-2"></div>
        <div className="all-dist-milk milk-1">🥛</div>
        <div className="all-dist-milk milk-2">🥛</div>
        <div className="all-dist-milk milk-3">🥛</div>
      </div>

      {/* Wavy Background */}
      <div className="all-dist-wave-bg">
        <svg className="all-dist-wave wave-top" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="rgba(76, 175, 80, 0.04)" 
            d="M0,160L48,154.7C96,149,192,139,288,154.7C384,171,480,213,576,213.3C672,213,768,171,864,138.7C960,107,1056,85,1152,96C1248,107,1344,149,1392,170.7L1440,192L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
          ></path>
        </svg>
        <svg className="all-dist-wave wave-bottom" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="rgba(62, 150, 231, 0.03)" 
            d="M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,213.3C672,224,768,224,864,213.3C960,203,1056,181,1152,186.7C1248,192,1344,224,1392,240L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>

      <Container>
        
        {/* Section Header */}
        <div className="all-dist-header text-center">
          <div className="all-dist-badge">
            <Users size={18} />
            <span>All Distributors</span>
          </div>
          <h2 className="all-dist-title">
            Browse our complete network of verified milk suppliers
          </h2>
        </div>

        {/* Distributors Grid */}
        <Row className="g-4 all-dist-grid">
          {visibleDistributors.map((distributor, index) => (
            <Col lg={3} md={6} sm={6} xs={12} key={distributor.id}>
              <div 
                className="all-dist-card-wrapper"
                style={{ animationDelay: `${(index % 8) * 0.08}s` }}
              >
                <DistributorCard distributor={distributor} featured={false} />
              </div>
            </Col>
          ))}
        </Row>

        {/* Load More Button */}
        {hasMore && (
          <div className="load-more-container text-center">
            <button className="load-more-btn" onClick={handleLoadMore}>
              Load More Distributors
              <ArrowRight size={20} className="ms-2" />
            </button>
          </div>
        )}

      </Container>
    </section>
  );
};

export default AllDistributorsSection;